import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query/query-keys';
import { apiFetch } from '@/lib/api/client';

async function approveTrip(tripId: string): Promise<void> {
  const response = await apiFetch(`/api/v1/business-trip-requests/${tripId}/approve`, {
    method: 'POST',
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    const message =
      payload && typeof payload === 'object' && 'error' in (payload as Record<string, unknown>)
        ? String(
            (payload as Record<string, { message?: string }>).error?.message ??
              'Failed to approve trip'
          )
        : 'Failed to approve trip';

    throw new Error(message);
  }
}

export function useApproveTrip() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: approveTrip,
    onSuccess: (_result, tripId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.trips });
      queryClient.invalidateQueries({ queryKey: queryKeys.tripApprovals });
      if (tripId) {
        queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) });
      }
    },
    onError: (error) => {
      console.error('Error approving trip:', error);
    },
  });
}
